import React from 'react';
import Loader from "../Loader";
import _ from "lodash";

function AlertCard(props) {
    const {auth, alerts, history, isLoading} = props;
    const {facilityDetails, sectionDetails} = auth;
    const facility = facilityDetails.facilityName;
    const section = sectionDetails.sectionName;
    return (
        <div className="section-alerts">
            <div className="card neighborhood-alerts alerts">
                <div className="card-header">Alerts</div>
                <div className="row">
                    {isLoading ? <Loader size="2x"/> : ''}
                    <div className="col-md-4 box-divider-right">
                        <div className="alert-box">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="alert-box-title">
                                            Urgent Total
                                    </div>
                                    <div className="alert-box-total" style={{color:'#f73f3f'}}>
                                        {alerts.totals ? alerts.totals.urgent.total : 0}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="alert-box-title text-left">
                                            By Type
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.urgent.type_total.resp_high : 0}</span> Resp. High
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.urgent.type_total.resp_low : 0}</span> Resp. Low
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.urgent.type_total.bed_exit : 0}</span> Bed. Exit
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="alert-box">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="alert-box-title">
                                            Warning Total
                                    </div>
                                    <div className="alert-box-total" style={{color:'#e9a921'}}>
                                        {alerts.totals ? alerts.totals.warning.total : 0}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="alert-box-title text-left">
                                            By Type
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.warning.type_total.resp_high : 0}</span> Resp. High
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.warning.type_total.resp_low : 0}</span> Resp. Low
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="alert-box no-border">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="alert-box-title">
                                            General Total
                                    </div>
                                    <div className="alert-box-total" style={{color:'#22a3bf'}}>
                                        {alerts.totals ? alerts.totals.general.total : 0}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="alert-box-title text-left">
                                            By Type
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.general.type_total.visit_soon : 0}</span> Visit Soon
                                    </div>
                                    <div className="alert-box-detail">
                                        <span className="alert-total">{alerts.totals ? alerts.totals.general.type_total.visit_required : 0}</span> Visit Required
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div className="pr-3">
                            <table className="table table-striped table-hover table-sm alert-room-table">
                                <thead>
                                    <tr>
                                        <th className="text-left">RESIDENT</th>
                                        <th>URGENT</th>
                                        <th>WARNING</th>
                                        <th>GENERAL</th>
                                        <th>TOTAL</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {_.map(
                                        _.get(props, "rooms", []),
                                        (room, key) => (
                                            <tr key={key} onClick={() => history.push(`/facilities/${facility}/sections/${section}/rooms/${room.room_id}/patient/${room.patient_id}`)}>
                                                <td className="text-left">
                                                    {_.defaultTo(room.patient_name)}
                                                </td>
                                                <td>
                                                    {room.active_alerts && room.active_alerts.urgent ? room.active_alerts.urgent : 0}
                                                </td>
                                                <td>
                                                    {room.active_alerts && room.active_alerts.warning ? room.active_alerts.warning : 0}
                                                </td>
                                                <td>
                                                    {room.active_alerts && room.active_alerts.general ? room.active_alerts.general: 0}
                                                </td>
                                                <td>
                                                    <strong>
                                                        {room.active_alerts && room.active_alerts.total ? room.active_alerts.total : 0}
                                                    </strong>
                                                </td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AlertCard;
